// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"446":"c619d2cf","462":"3f2f48d3","483":"7ed25f8e","570":"90cc3374","998":"ab258c77"}[chunkId] + ".chunk.js";
};